import { useTranslation } from 'react-i18next';
import RecruitmentHeader from '../../../components/common/layout/RecruitmentHeader'
import { ApplicationSvg, Logout, ProfileSvg } from '../../../components/common/svg/AllSvg';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { authActions } from '../../../shared/store/auth-Slice';
import { useDispatch } from 'react-redux';
import AppliedJobs from '../../../components/corporate/recruitment/AppliedJobs';
import EditProfile from '../../../components/corporate/recruitment/EditProfile';
import Canonical from '../../../components/common/layout/Canonical';

const MyProfile = () => {
    const { t } = useTranslation('common');
    const params = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const tabs: any = [
        { name: t("profile.tabs.profile"), key: "profile", url: "/profile", icon: ProfileSvg },
        { name: t("auth.profile.my_application"), key: "applied-jobs", url: "/applied-jobs", icon: ApplicationSvg },
    ]

    const handleLogout = async () => {
        dispatch(authActions.logout());
        if (window?.location?.pathname.includes("/admin")) {
            dispatch(authActions.adminDetail(null))
            navigate(!!params?.lang ? `/${params?.lang}/admin/login` : "/admin/login")
        } else {
            dispatch(authActions.userDetail(null))
            navigate(!!params?.lang ? `/${params?.lang}` : "/")
        }
    }

    return (
        <div className='bg-white dark:bg-bgDarkDull'>
            <Canonical />
            <RecruitmentHeader />
            <div id="home">
                <div className="container py-[25px] w-full h-full grid grid-cols-1">
                    <div className="flex w-full h-full">
                        <div className="py-[30px] xlx:py-[35px] pr-[30px] xlx:pr-[35px] hidden flex-col gap-[20px] border-r border-primary border-opacity-[0.2] h-full min-w-[235px] md:flex">
                            <h3 className="text-primaryText dark:text-white font-semibold">{t("profile.settings")}</h3>

                            <div className="flex flex-col gap-[8px]">
                                {Array.isArray(tabs) && tabs?.map((item: any, index: number) => (
                                    <Link to={!!params?.lang ? `/${params?.lang + item?.url}` : `${item?.url}`} key={index} className={`px-[13px] py-[8px] flex items-center gap-[8px] w-full ${window.location.pathname?.includes(item?.key) ? "bg-primary bg-opacity-[0.1] text-primaryText dark:text-white" : "text-blackDull dark:text-textBlackDull focus:bg-[#F5F5F5] hover:bg-[#F5F5F5] dark:hover:bg-[#4c4e5e5e] dark:focus:bg-[#4c4e5e5e]"} rounded-[7px] font-medium text-base leading-tight`} >
                                        <div className="min-w-[19px] min-h-[19px] flex items-center justify-center">
                                            <item.icon className={`${window.location.pathname?.includes(item?.key) ? "fill-primaryText dark:fill-white" : "fill-blackDull dark:fill-textBlackDull"}`} />
                                        </div>
                                        {item?.name}
                                    </Link>
                                ))}

                                <div className="w-full border-t border-primary border-opacity-[0.2]">
                                    <button className="w-full  flex items-center gap-[8px] text-danger dark:text-darkDanger mt-[7px] font-medium text-base leading-tight px-[13px] py-[8px] focus:bg-[#F5F5F5] hover:bg-[#F5F5F5] dark:hover:bg-[#4c4e5e5e] dark:focus:bg-[#4c4e5e5e] rounded-[7px]" onClick={handleLogout}>
                                        <div className="min-w-[19px] min-h-[19px] flex items-center justify-center">
                                            <Logout className="min-w-[16px] dark:stroke-darkDanger stroke-danger" />
                                        </div>

                                        {t("auth.profile.logout")}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="fixed left-0 right-0 bottom-[30px] flex items-end justify-center z-[1] md:hidden">
                            <div className="bg-white shadow-[0px_4px_6px_-4px_rgba(24,39,75,0.12),0px_8px_8px_-4px_rgba(24,39,75,0.08)] rounded-[10px] w-fit h-fit px-[20px] py-[8px] flex items-center gap-[15px]">
                                {Array.isArray(tabs) && tabs?.map((item: any, index: number) => (
                                    <Link aria-label={item?.name} title={item?.name} to={!!params?.lang ? `/${params?.lang + item?.url}` : `${item?.url}`} key={index} className={`min-w-[30px] min-h-[30px] flex items-center justify-center ${window.location.pathname?.includes(item?.key) ? "bg-primary bg-opacity-[0.1] rounded-full" : ""}`} >
                                        <item.icon className={`${window.location.pathname?.includes(item?.key) ? "fill-primaryText" : "fill-blackDull"}`} />
                                    </Link>
                                ))}
                            </div>
                        </div>
                        <div className="w-full md:w-[calc(100%-235px)] h-full">
                            {window.location.pathname?.includes?.("applied-jobs") ?
                                <AppliedJobs /> :
                                window.location.pathname?.includes?.("profile") ?
                                    <EditProfile /> :
                                    <></>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default MyProfile;